import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import VuePluralize from 'vue-pluralize'
import store from './store'

Vue.config.productionTip = false

Vue.filter('nearestHalf', function (value: number) {
  return Math.round(value / 0.5) * 0.5;
})

Vue.use(VuePluralize)

new Vue({
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
